import { getClient } from '@zg-rentals/ts-client-http-client';

export const httpClient = getClient().extend({
  prefixUrl: __DEV__ ? `${__API__}rental` : '/rental',
});

export const rentalManagerHttpClient = getClient().extend({
  prefixUrl: __DEV__ ? `${__API__}` : '/',
});
